import React, { useState }  from "react";
import { useSelector } from 'react-redux';
import {Link} from "react-router-dom";
import TextInput from "../../../../components/TextInput";
import Dropdown from "../../../../components/Dropdown";
import { getItemsDay, getItemsMonth, getItemsYear } from "utils/util";
import { WORKING_AGE } from '../../../../constants/index'


const BasicInfoSection = ({ 
  formData, 
  setFormData, 
  setValueDate, 
  dayOptions, 
  setDayOptions, 
  setDisplay }: any) => {
    const { talent, errors, genderOptions, residenceOptions } = useSelector((state: any) => state.talentMypage)

    const dataYear = getItemsYear(new Date().getFullYear() - WORKING_AGE, 100 - WORKING_AGE);
    const dataMonth = getItemsMonth();
    const dataDate = [];
    for (let i = 1; i <= 31; i++) {
    const id = String(i).padStart(2, '0');
    dataDate.push({ id: i, name: `${id}` });
    }
    const dataYearJoinLeave = getItemsYear(null);
    const dataMonthJoinLeave = getItemsMonth();
    const [dataDayJoinLeave, setDataDayJoinLeave] = useState(getItemsDay(formData?.leave_company_year?.id, formData?.leave_company_month?.id));

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setDisplay(true)
    };
    const handleBlurInput = (e: any) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value.trim(),
        }));
    };

    const getValueByObject = (object: any) => {
        if (!object) {
            return null;
        }
        return object.id;
    };

    const changeYearOfBirth = (value: any, name: any) => {
      let dateOfBirth = formData.birth_day
    
      if (value && getValueByObject(value)
        && formData.birth_month && getValueByObject(formData.birth_month)) {
        const dataDate = getItemsDay(
          getValueByObject(value),
          getValueByObject(formData.birth_month),
        );
        setDayOptions(dataDate);

        if(dateOfBirth && !dataDate.some(item => item.id === dateOfBirth.id)) {
          dateOfBirth = null
        }
      }
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        birth_day: dateOfBirth
      }));
      setDisplay(true)
    };

    const changeMonthOfBirth = (value: any, name: any) => {
      let dateOfBirth = formData.birth_day

    if (formData.birth_year && getValueByObject(formData.birth_year)
        && value && getValueByObject(value)) {
        const dataDate = getItemsDay(
          getValueByObject(formData.birth_year),
          getValueByObject(value),
        );
        setDayOptions(dataDate);

        if(dateOfBirth && !dataDate.some(item => item.id === dateOfBirth.id)) {
          dateOfBirth = null
        }
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      birth_day: dateOfBirth
    }));
    setDisplay(true)
  };

    const changeYearOfLeave = (value: any) => {
        let leave_company_day = formData.leave_company_day
    
        if(value && getValueByObject(value) && formData.leave_company_month && getValueByObject(formData.leave_company_month)) {
            const dataDate = getItemsDay(
                getValueByObject(value),
                getValueByObject(formData.leave_company_month),
            );
            setDataDayJoinLeave(dataDate)
        
            if(leave_company_day && !dataDate.some(item => item.id === leave_company_day.id)) {
              leave_company_day = null
            }
        }
    
        setFormData((prev) => ({ 
            ...prev, 
            leave_company_year: value, 
            leave_company_day: leave_company_day 
        }))
    };
  
    const changeMonthOfLeave = (value: any) => {
        let leave_company_day = formData.leave_company_day
  
        if(formData.leave_company_year && getValueByObject(formData.leave_company_year) && value && getValueByObject(value)) {
            const dataDate = getItemsDay(
                getValueByObject(formData.leave_company_year),
                getValueByObject(value),
            );
            setDataDayJoinLeave(dataDate)
  
            if(leave_company_day && !dataDate.some(item => item.id === leave_company_day.id)) {
              leave_company_day = null
            }
        }
  
        setFormData((prev) => ({ 
            ...prev, 
            leave_company_month: value, 
            leave_company_day: leave_company_day 
        }))
    };

    return (
        <>
        <p className="alu-text-base-2 text-base font-bold mb-4">基本情報</p>
            <div className="mb-4">
              <label
                className="block mb-1 text-sm alu-text-base-1"
                htmlFor="fullName"
              >
                氏名
              </label>
              <div className="flex items-top gap-2">
                <div className="flex-1">
                  <TextInput
                    size="md"
                    error={errors?.last_name}
                    errorText={errors?.last_name}
                    id="last_name"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    onBlur={handleBlurInput}
                    placeholder="姓"
                    maxLength={100}
                  />
                </div>
                <div className="flex-1">
                  <TextInput
                    size="md"
                    error={errors?.first_name}
                    errorText={errors?.first_name}
                    id="first_name"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    onBlur={handleBlurInput}
                    placeholder="名"
                    maxLength={100}
                  />
                </div>
              </div>
            </div>
            <div className="mb-4">
              <label
                className="block mb-1 text-sm alu-text-base-1"
                htmlFor="katakanaName"
              >
                氏名（カナ）
              </label>
              <div className="flex items-top gap-2">
                <div className="flex-1">
                  <TextInput
                    size="md"
                    error={errors?.last_name_kana}
                    errorText={errors?.last_name_kana}
                    id="last_name_kana"
                    name="last_name_kana"
                    value={formData.last_name_kana}
                    onChange={handleChange}
                    onBlur={handleBlurInput}
                    placeholder="セイ"
                    maxLength={100}
                  />
                </div>
                <div className="flex-1">
                  <TextInput
                    size="md"
                    error={errors?.first_name_kana}
                    errorText={errors?.first_name_kana}
                    id="first_name_kana"
                    name="first_name_kana"
                    value={formData.first_name_kana}
                    onChange={handleChange}
                    onBlur={handleBlurInput}
                    placeholder="メイ"
                    maxLength={100}
                  />
                </div>
              </div>
            </div>
            <div className="mb-4">
              <label
                className="block mb-1 text-sm alu-text-base-1"
                htmlFor="email"
              >
                メールアドレス
              </label>
              <TextInput
                size="md"
                error={errors?.email}
                errorText={errors?.email}
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                onBlur={handleBlurInput}
                placeholder="sample@sample.com"
                maxLength={254}
              />
            </div>
            <div className="mb-4">
              <span className="alu-text-base-1 text-sm mb-1">生年月日</span>
              <div className="flex items-top gap-2">
                <div className="w-1/3">
                  <Dropdown
                    inputWidth="full"
                    placeholder={talent?.birth_year ? talent?.birth_year : '年'}
                    options={dataYear}
                    value={formData.birth_year}
                    onChange={(value: any) => changeYearOfBirth(value, "birth_year")}
                    unitLabel="年"
                    isUnitLabelHavingMargin={false}
                  />
                </div>
                <div className="w-1/3">
                  <Dropdown
                    inputWidth="full"
                    placeholder={talent?.birth_month ? talent?.birth_month : '月'}
                    options={dataMonth}
                    value={formData.birth_month}
                    onChange={(value: any) => changeMonthOfBirth(value, "birth_month")}
                    unitLabel="月"
                  />
                </div>
                <div className="w-1/3">
                  <Dropdown
                    inputWidth="full"
                    placeholder='日'
                    error={errors.birth_day}
                    errorText={errors.birth_day}
                    options={dayOptions}
                    value={formData.birth_day}
                    onChange={(value: any) => {
                      setFormData((prev) => ({ ...prev, birth_day: value }));
                      setDisplay(true);
                    }}
                    unitLabel="日"  
                  />
                </div>
              </div>
            </div>
            <div className="mb-4">
              <span className="alu-text-base-1 text-sm mb-1">居住地</span>
              <Dropdown
                customStyle="!min-w-[8.0625rem]"
                placeholder='選択してください'
                options={residenceOptions}
                value={formData.city}
                onChange={(value: any) => {
                  setFormData((prev) => ({ ...prev, city: value }))
                  setDisplay(true)
                }
                }
              />
            </div>
            <div className="mb-4">
              <span className="alu-text-base-1 text-sm mb-1">性別</span>
              <Dropdown
                customStyle="!min-w-[8.0625rem]"
                placeholder='選択してください'
                options={genderOptions}
                value={formData.gender}
                onChange={(value: any) => {
                  setFormData((prev) => ({ ...prev, gender: value }))
                  setDisplay(true)
                }
                }
              />
            </div>
            <div className="mb-4">
              <span className="alu-text-base-1 text-sm">{talent?.last_company?.name} の在籍期間</span>
              <div>
                <label className="block text-sm alu-text-base-1 mb-1">
                  入社年月
                </label>
                <div className="flex items-top">
                  <div className="w-1/3 mr-2">
                    <Dropdown
                      inputWidth="full"
                      placeholder={"ー"}
                      options={dataYearJoinLeave}
                      value={formData.join_company_year}
                      unitLabel="年"
                      onChange={(value: any) => {setFormData((prev) => ({ ...prev, join_company_year: value })); setDisplay(true);}}
                    />
                  </div>
                  <div className="w-1/3 mr-2">
                    <Dropdown
                      inputWidth="full"
                      placeholder={"ー"}
                      options={dataMonthJoinLeave}
                      value={formData.join_company_month}
                      unitLabel="月"
                      onChange={(value: any) => {setFormData((prev) => ({ ...prev, join_company_month: value })); setDisplay(true);}}
                    />
                  </div>
                  <div className="w-1/3 mt-2">〜</div>
                </div>
              </div>
              <div className="flex items-top items-center">
                {errors?.join_company_year && (<p className="alu-text-error text-sm mt-2">{errors?.join_company_year ? `*${errors?.join_company_year}` : ""}</p>)}
              </div>
            </div>
            <div className="mb-4">
              <div>
                <label className="block mb-1 text-sm alu-text-base-1">
                  退社年月日
                </label>
                <div className="flex items-top">
                  <div className="w-1/3 mr-2">
                    <Dropdown
                      inputWidth="full"
                      placeholder={"ー"}
                      options={dataYearJoinLeave}
                      value={formData.leave_company_year}
                      unitLabel="年"
                      onChange={(value: any) => {changeYearOfLeave(value); setDisplay(true);} }
                    />
                  </div>
                  <div className="w-1/3 mr-2">
                    <Dropdown
                      inputWidth="full"
                      placeholder={"ー"}
                      options={dataMonthJoinLeave}
                      value={formData.leave_company_month}
                      unitLabel="月"
                      onChange={(value: any) => {changeMonthOfLeave(value); setDisplay(true);} }
                    />
                  </div>
                  <div className="w-1/3">
                    <Dropdown
                      inputWidth="full"
                      placeholder={"ー"}
                      options={dataDayJoinLeave}
                      value={formData.leave_company_day}
                      unitLabel="日"
                      onChange={(value: any) => {setFormData((prev) => ({ ...prev, leave_company_day: value })); setDisplay(true);}}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-[25px] w-fit">
              <Link to={'/talent/mypage/change-password'} target="_blank">
              <span className="fcursor-pointer flex gap-2 alu-text-title text-sm items-center p-1 rounded hover:bg-[#FFF3E5] w-fit">
                パスワードを変更
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z"
                    fill="#FF861A"
                  />
                </svg>
              </span>
              </Link>
            </div>
        </>
    )
};

export default BasicInfoSection;